var map = {
	"./24ki05.jpg": 9093,
	"./CivilTT.png": 6327,
	"./cutie_trick.png": 4250,
	"./kswmcHi.png": 8996,
	"./museum.png": 8520,
	"./prologram.png": 9965,
	"./sample.png": 8727,
	"./txkodo.png": 1073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8568;